import "react-flags-select/scss/react-flags-select.scss";

import { FlagIcon } from "react-flag-kit";
import { useState, useEffect } from "react";
import Select from "@material-ui/core/Select";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import { useTranslation } from "react-i18next";
import MenuItem from "@material-ui/core/MenuItem";
import { useDispatch, useSelector } from "react-redux";
import DialogTitle from "@material-ui/core/DialogTitle";
import { useNavigate, useParams } from "react-router-dom";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

import {
  putLingoLanguages,
  getGlobalLanguages,
  postLingoLanguages,
  deleteLingoLanguages,
} from "../../store/middleware";
import countries from "./countries.json";
import Header from "../../components/Header/NewHeader";
import SideMenu from "../../components/SideMenu/SideMenu";
import Engrenagem from "../../assets/images/icons/icon_settings_header.svg";

import { Language } from "./styles";

function Languages() {
  let { id } = useParams();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { allLingos } = useSelector((state) => state.genericReducer);

  const [open, setOpen] = useState(false);
  const [languagesName, setLanguagesName] = useState([]);
  const [form, setForm] = useState({
    flag: 0,
    active: false,
    languageId: "",
    description: "",
    customLang: false,
  });

  const getData = async () => {
    const response = await dispatch(getGlobalLanguages());
    setLanguagesName(response);

    if (id) {
      const { flag, language, description, active, customLang } = allLingos.find((item) => item.id === Number(id));
      const idLanguage = response.filter((item) => item.name === language.name);
      const flagFormatted = !customLang ? flag.split("-")[0] : flag.split("-")[1];

      setForm({ flag: flagFormatted, languageId: idLanguage[0].id, description, active, customLang });
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;
    setForm((state) => ({ ...state, [name]: newValue }));
  };

  const handlePost = () => {
    if (form.languageId === "" || form.flag === 0 || form.description === "") return;

    let flagFormatted = "";

    if (form.customLang) {
      flagFormatted = "CS-" + form.flag.toUpperCase().concat("-") + form.description.substring(0, 2).toUpperCase();
    } else {
      flagFormatted = form.flag;
    }

    const payload = {
      flag: flagFormatted,
      active: form.active,
      customLang: form.customLang,
      description: form.description,
      languageId: Number(form.languageId),
    };

    if (!id) {
      dispatch(postLingoLanguages(payload)).then(() => navigate(-1));
    } else {
      dispatch(putLingoLanguages(id, payload)).then(() => navigate(-1));
    }
  };

  const handleDelete = async (e) => {
    e.preventDefault();

    const response = await dispatch(deleteLingoLanguages(id));
    if (!response) return;

    setOpen(false);
    navigate(-1);
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="view">
      <SideMenu />
      <section>
        <Header t={t} title={t("LANGUAGES")} icon={<img src={Engrenagem} alt="Engrenagem" />} typeIcon="custom" />

        <div className="content">
          <Language>
            <div className="bigBox teste">
              <h2>{!id ? "Add New Language" : form.description}</h2>

              <div className="planInfo">
                <form className="formulario">
                  <div className="country">
                    <div className="countryTop">
                      <div>
                        <label htmlFor="country">Flag</label>
                        <span>{t("REQUIRED")}</span>
                      </div>

                      <Select
                        name="flag"
                        disableUnderline
                        value={form.flag}
                        onChange={handleChange}
                        className="input-lingo"
                        disabled={countries.length === 1}
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <MenuItem key={"mi" + -1} value={0}>
                          {t("SELECT")}
                        </MenuItem>
                        {countries?.map((item) => (
                          <MenuItem key={item.code} value={item.code}>
                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                              <FlagIcon code={item.code ? item.code : ""} />
                              {item.name}
                            </div>
                          </MenuItem>
                        ))}
                      </Select>
                    </div>

                    <div className="countryTop">
                      <div>
                        <label htmlFor="name">{t("NAME")}</label>
                        <span>{t("REQUIRED")}</span>
                      </div>
                      <select value={form.languageId} onChange={handleChange} name="languageId" className="input-lingo">
                        <option value={""}>Select</option>
                        {languagesName?.map((nameItem) => (
                          <option key={nameItem.id} value={nameItem.id}>
                            {nameItem.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div>
                    <label htmlFor="gender">{t("DESCRIPTION")}</label>
                    <span>{t("REQUIRED")}</span>
                  </div>
                  <input
                    name="description"
                    className="inputMobile"
                    onChange={handleChange}
                    value={form.description}
                    placeholder="Description of the Language"
                  />
                  <div className="country">
                    <div>
                      <label htmlFor="gender">{t("ACTIVE")}?</label>
                      <div className="switchBox">
                        <div className="switch__container addInput">
                          <input
                            name="active"
                            type="checkbox"
                            id="switch-shadow2"
                            checked={form.active}
                            onChange={handleChange}
                            className="switch switch--shadow"
                          />
                          <label htmlFor="switch-shadow2">
                            <span>{form.active ? "Yes" : "No"}</span>
                          </label>
                        </div>
                      </div>
                    </div>

                    <div>
                      <label htmlFor="gender">Custom?</label>
                      <div className="switchBox">
                        <div className="switch__container addInput">
                          <input
                            type="checkbox"
                            name="customLang"
                            id="switch-shadow3"
                            onChange={handleChange}
                            checked={form.customLang}
                            className="switch switch--shadow"
                          />
                          <label htmlFor="switch-shadow3">
                            <span>{form.customLang ? "Yes" : "No"}</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  {id && (
                    <Button onClick={() => setOpen(true)} className="deleteType">
                      {t("DELETE")} {t("LANGUAGE")}
                    </Button>
                  )}
                </form>
              </div>
            </div>

            <div className="button">
              <button className="back" onClick={() => navigate(-1)}>
                <i className="fa fa-angle-left" aria-hidden="true"></i>Back
              </button>
              <button className="save" onClick={handlePost}>
                {t("BTN_SAVE")}
              </button>
            </div>
          </Language>

          <Dialog
            open={open}
            keepMounted
            onClose={() => setOpen(false)}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{"Please confirm"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                {"Do you really want to remove the language ?" + form.description}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleDelete} color="primary">
                {"Yes, delete"}
              </Button>
              <Button onClick={() => setOpen(false)} color="primary">
                {"Cancel"}
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </section>
    </div>
  );
}

export default Languages;
